import { BasicType } from "@easy-email-pro-core/constants";
import { ElementChildren, SpacerElement } from "@easy-email-pro-core/typings";
import { BlockRenderer } from "../BlockRenderer";
import { isValidReactChildren } from "@easy-email-pro-core/utils/isValidReactChildren";
import React from "react";
import { RecursivePartial } from "@easy-email-pro-core/typings/helper";

export type SpacerProps = RecursivePartial<SpacerElement["attributes"]> & {
  idx?: string | null;
  children?: ElementChildren | SpacerElement["children"];
  data?: SpacerElement["data"];
};

export function Spacer(props: SpacerProps) {
  const { data, idx, children: propsChildren, ...rest } = props;

  const node: SpacerElement = {
    type: BasicType.SPACER,
    data: data || {},
    attributes: { ...rest },
    children: isValidReactChildren(propsChildren) ? [] : propsChildren || [],
  };

  return (
    <BlockRenderer
      idx={idx}
      node={node}
      children={isValidReactChildren(propsChildren) ? propsChildren : null}
    />
  );
}
